import { all, call, delay, takeEvery, put } from "redux-saga/effects";

import { rollbarXHRError } from "lib/rollbar";
import { patch } from "redux/fetch";

import {
    hideToast,
    showInfoToast,
    showWarningToast,
    showErrorToast,
    setUserAction,
} from "./actions";

function* patchUserAction({ payload }) {
    const data = { action_state: payload };

    try {
        yield call(patch, "/api/v1/user-action/", data);
    } catch (e) {
        rollbarXHRError("Failed to set user_action", e, data);
    }
}

function* runHideToast({ payload: { hideDelayMS = null } }) {
    yield delay(hideDelayMS || 3000);
    yield put(hideToast());
}

export default function* wsSagas() {
    yield all([
        takeEvery(setUserAction, patchUserAction),
        takeEvery([showInfoToast, showWarningToast, showErrorToast], runHideToast),
    ]);
}
